import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import '../styles/components/popup.scss';
import { TitleText } from '../pages/start';
import { faMicrophoneSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from '../components/footer';
import { faLock } from "@fortawesome/pro-solid-svg-icons";
import isMobile from '../utils/mobilecheck';
import Hexagon from "./hexagon";
import { tspan } from '../utils/i18n';
import { micAccess } from '../utils/alt-tags';


export const POPUP_TYPE = {
    crios: 'crios',
    desktop: 'desktop',
    mobile: 'mobile'
};

const SubTitle = styled.span`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 17px;
  height: 24px;
`;

const SubText = styled.span`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  text-align: left;
  padding-left: 1rem;
`;
export const GreyDiv = styled.div`
     display: flex;
     justify-content: center;
     align-items: center;
     width: 100%;
     height: ${(props) => (props.bottom ? '46px':'66px')} ;
     text-align: center;
     background: #F1F1F1;
     border-radius: 7px 7px 0px 0px;
`;
const SlashedMic = styled(FontAwesomeIcon)`
  font-style: normal;
  font-weight: 300;
  font-size: 48px;
  line-height: 48px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
  color: #C4C4C4;
  border-radius: 4px;
  margin-left: 2rem;
`;
const ColoredDiv= styled.div`
  height: 3rem;
  margin-bottom: 7px;
  width: 100%;  
  background: #F1F1F1;
  display: flex;
  justify-content: center;
  align-items: center;
  >:first-child {
      cursor: pointer;
    }
`;
const CopyButton = styled.button`
  background: #FFFFFF;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: Titillium Web;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  padding: 0.5rem 6rem;
  i {
   color: #2E394F;
   margin-right: 5px;
  }
`;
const AlertText = styled.div`
    height: 35px;
    text-align: center;
    font-size: 12px;
    line-hieght: 12px;
  -webkit-animation: seconds 1.0s forwards;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-delay: 1s;
  animation: seconds 1.0s forwards;
  animation-iteration-count: 1;
  animation-delay: 1s;
  position: relative;
    

@-webkit-keyframes seconds {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
    hieght: 0;
  }
}
@keyframes seconds {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
       hieght: 0;

  }
}
`;

export default class Popup extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        type: PropTypes.oneOf(Object.values(POPUP_TYPE))
    }
    state = {
        textCopied: false,
    };
    renderInApp() {
        const { pluginMode, settings } = this.props;
        return (
            <>
                <GreyDiv>
                    {/* Title for final page */}
                    <TitleText>{tspan('popup-fail-title')}</TitleText>
                </GreyDiv>
                <SubTitle>{isMobile.iOS() ? 'Please open in Safari' : "Please open in Chrome"}</SubTitle>
                <div className='split-view horiz' style={{padding: '0 4rem 0 3rem'}}>
                    <SlashedMic icon={faMicrophoneSlash} style={{paddingRight:'16px'}}/>
                    <SubText style={{textAlign:'left'}}>
                        {isMobile.iOS() ? tspan('popup-subTitle-safari') : tspan('popup-subTitle-chrome')}
                    </SubText>
                </div>
                {!pluginMode ? (
                    <>
                        <div className='split-view horiz' >
                            <CopyButton onClick={() => this.copyChannelLink()}>
                                <i className="fas fa-copy" />
                                TAP TO COPY LINK
                            </CopyButton>
                        </div>
                        {this.state.textCopied ?
                            <AlertText className="alert alert-success" >
                                <strong>Channel Link Copied!</strong>
                            </AlertText>
                            : ''}
                    </>
                ):''
                }
                <ColoredDiv className="buttons" style={{}}>
                    <Hexagon common={settings.common} icon={faLock} arrow={false} title={micAccess}/>
                </ColoredDiv>
            </>
        );
    }

    renderDesktop() {
        const { pluginMode, settings } = this.props;
        return (
            <>
                <GreyDiv>
                    {/* Title for final page */}
                        <TitleText>{tspan('popup-fail-title')}</TitleText>
                </GreyDiv>
                <SubTitle>{tspan('popup-failure')}</SubTitle>
                <div className='split-view horiz' style={{padding:pluginMode ? '0 5rem 0 3rem' : '0 5.5rem 0 4.5rem'}}>
                    <SlashedMic icon={faMicrophoneSlash}/>
                    <SubText>
                        {tspan('popup-subTitle-desktop')}
                    </SubText>
                </div>
                {!pluginMode ? (
                    <>
                    <SubText>Please check and then try again</SubText>
                    <div className='split-view horiz' style={{padding: '0 6rem'}}>

                    <SubText
                    style={{
                        paddingRight:"16px"}}>
                        {tspan('popup-subText-qrcode')}
                    </SubText>
                        <img src={`${process.env.PUBLIC_URL}/img/qrcode.png`} alt="QRCode"/>
                    </div>
                        </>
                ):''
                }
                <ColoredDiv className="buttons" style={{}}>
                    <Hexagon common={settings.common} icon={faLock} arrow={false} title={micAccess} />
                </ColoredDiv>
            </>
        )
    }

    renderMobile() {
        const { pluginMode, settings } = this.props;
        return (
            <>
                <GreyDiv>
                    {/* Title for final page */}
                    <TitleText>{tspan('popup-fail-title')}</TitleText>
                </GreyDiv>
                <SubTitle>{tspan('popup-failure')}</SubTitle>
                <div className='split-view horiz' style={{padding: '0 4rem 0 3rem'}}>
                    <SlashedMic icon={faMicrophoneSlash} style={{paddingRight:'16px'}}/>
                    <SubText style={{textAlign:'left'}}>
                        {tspan('popup-subTitle-mbl')}
                    </SubText>
                </div>
                {!pluginMode ? (
                    <>
                        <div className='split-view horiz' >
                        <CopyButton onClick={() => this.copyChannelLink()}>
                            <i className="fas fa-copy" />
                            TAP TO COPY LINK
                        </CopyButton>
                        </div>
                        {this.state.textCopied ?
                        <AlertText className="alert alert-success" >
                            <strong>Channel Link Copied!</strong>
                        </AlertText>
                            : ''}
                    </>
                ):''
                }
                <ColoredDiv className="buttons">
                    <Hexagon common={settings.common} icon={faLock} arrow={false} title={micAccess} />
                </ColoredDiv>
            </>
        )
    }

    copyChannelLink(){
        const { settings: { common } } = this.props;

        const nhsUrl = "https://blessourheroes.org/";
        if (navigator.clipboard) {
            navigator.clipboard.writeText(common.isPublicHosted ? nhsUrl : window.location.href)
                .catch(err => {
                    console.error('Could not copy text: ', err);
                });
        } else {
            const channelLink = document.createElement('span');
            channelLink.style.whiteSpace = 'pre';
            channelLink.textContent = common.isPublicHosted ? nhsUrl : window.location.href;
            document.body.appendChild(channelLink);
            const selection = window.getSelection();
            selection.removeAllRanges();
            const range = document.createRange();
            range.selectNode(channelLink);
            selection.addRange(range);
            document.execCommand('copy');
            selection.removeAllRanges();
            document.body.removeChild(channelLink);
        }
       this.setState({textCopied : true});
       setTimeout(()=> this.setState({textCopied : false } ),1500)
    }
    render() {
        const { show, type } = this.props;
        return (
            <div className={`app-popup ${show ? '' : 'hide'}`}>
                <div className="popup-content">
                    {type &&
                        type === POPUP_TYPE.crios ? this.renderInApp() :
                        type === POPUP_TYPE.desktop ? this.renderDesktop() :
                            type === POPUP_TYPE.mobile ?
                                ((isMobile.iOS() && isMobile.Safari()) ||
                                    (isMobile.Android() && isMobile.CriAnd() && !isMobile.inApp()))
                                    ? this.renderMobile() : this.renderInApp() :
                                null
                    }
                </div>
                <div className="popup-footer">
                    {
                        // type === POPUP_TYPE.crios ?
                        //     <a href={window.location.href}>
                        //         <button id="iOS-btn">TAP AND HOLD TO COPY LINK</button>
                        //     </a>
                        //     :
                        //     <span>Refresh to try again</span>

                  <Footer/>
                    }
                </div>
            </div>
        )
    }
}
